import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {CondicionesComponent} from '../condiciones.component'
//Services
import {ConditionService} from 'src/app/core/services/parameters/condition.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearCondicionModal implements OnInit {

  newConditionForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<CondicionesComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private conditionService: ConditionService
  ) {
  }

  ngOnInit(): void {
    this.newConditionForm = this.fb.group({
      condition: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newConditionForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newConditionForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.condition
      }
      this.conditionService.createCondition(data).subscribe(_res => {
        this.alert.setNotice('Condición creada correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear la condición', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
